export const timeUtils = {
    data: function () {
        return {
            DAY_IN_MILLIS: (24 * 60 * 60 * 1000) - 1
        }
    },

    methods: {
        getYearList: function () {
            const start = 2018
            const currentYear = new Date().getFullYear()
            const result = []
            let year = start
            while (year <= currentYear) {
                result.push(year)
                year++
            }
            return result
        },
        getDateFromString: function (dateStr) {
            if (dateStr) {
                return new Date(this.setTime(dateStr))
            }
            return null
        },
        getDate: function (dateStr, ignoreTime = false) {
            if (dateStr) {
                if(ignoreTime){
                    return this.$d(new Date(dateStr), { dateStyle: 'long', timeStyle: undefined })
                }
                return this.$d(new Date(dateStr), { dateStyle: 'short', timeStyle: 'short' })
            }
            return ''
        },
        getDateString: function (dateStr) {
            if (dateStr) {
                return this.$d(new Date(this.setTime(dateStr)), { dateStyle: 'short', timeStyle: 'short' })
            }
            return ''
        },
        getDateStringHoursMinutesSeconds: function (dateStr) {
            if (dateStr) {
                const date = new Date(this.setTime(dateStr));
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
                return `${hours}:${minutes}:${seconds}`;
            }
            return '';
        },
        getShortDateString: function (dateStr) {
            if (dateStr) {
                return this.$d(new Date(this.setTime(dateStr)),  { dateStyle: 'short' })
            }
            return ''
        },
        getShortDateWithoutTimezone: function (dateStr) {
            if (dateStr) {
                return this.$d(new Date(dateStr), { dateStyle: 'short' })
            }
            return ''
        },
        getWeekDay: function (dateStr) {
            if (dateStr) {
                return this.$d(new Date(this.setTime(dateStr)), 'weekDay')
            }
            return ''
        },
        setTime: function (timeStr) {
            // This handles only timezones + UTC - that is enough for now
            // Server usually return with timezone
            if (timeStr.indexOf('+') < 0) {
                timeStr += '+00:00'
            }
            return timeStr
        },
        toLocalTime: function (timeStr) {
            return this.getDateString(timeStr)
        },

        getDuration: function (start, end) {
            const startDate = new Date(start)
            const endDate = new Date(end)
            const dif = endDate - startDate
            let mins = Math.round(dif / 60 / 1000)
            const hrs = Math.floor(mins / 60)
            mins -= hrs * 60
            if (mins < 10) {
                return hrs + ':0' + mins
            }
            return hrs + ':' + mins
        },
        getWorkTime: function (mins) {
            if (mins) {
                const hrs = Math.floor(mins / 60)
                mins -= hrs * 60
                if (Math.round(mins) < 10) {
                    return hrs + ':0' + Math.round(mins)
                }
                return hrs + ':' + Math.round(mins)
            } else {
                return 0
            }
        },
        getWorkDays: function (min){
            let d = Math.floor(min/1440); // 60*24
            let h = Math.floor((min-(d*1440))/60);
            let m = Math.round(min%60);

            if(d>0){
                return(d + " d " + h + " h");
            }else{
                return(h + " h "+m+" m");
            }
        },

        getFormattedDateTimeForExcelExport: function (dateStr) {
                    if (dateStr) {
                        const date = new Date(dateStr)
                        return ('0' + date.getDate()).slice(-2) + ':' +
                            ('0' + (date.getMonth() + 1)).slice(-2) + ':' +
                            date.getFullYear() + ' ' +
                            ('0' + date.getHours()).slice(-2) + ':' +
                            ('0' + date.getMinutes()).slice(-2)
                    }
                    return ''
                },
        getDurationInMinutes: function (start, end) {
            const startDate = new Date(start)
            const endDate = new Date(end)
            const dif = endDate - startDate
            return Math.round(dif / 60 / 1000)
        },
        timestampToDateInput: function (timestamp) {
            if (timestamp < 1) {
                return null
            }
            var date = new Date(timestamp)
            var year = date.getFullYear()
            var month = date.getMonth() + 1
            var day = date.getDate()
            var result = year + '-'
            if (month < 10) {
                result += '0'
            }
            result += month + '-'
            if (day < 10) {
                result += '0'
            }
            result += day
            return result
        },
        timestampToLocalTime: function (timestamp) {
            return this.$d(new Date(timestamp), { dateStyle: 'short', timeStyle: 'short' })
        },
        localTimeToUtcTime: function (datetime) {
            const date = new Date(datetime)
            date.setTime(date.getTime() + date.getTimezoneOffset() * 60 * 1000)
            return date
        },
        getEndOfTheDay: function (date, zoneConversion = true) {
            let startOfDay = new Date(date)
            startOfDay.setHours(0, 0, 0, 0)
            let endOfDay = startOfDay.getTime() + this.DAY_IN_MILLIS // add a whole day to get the values for the day
            return zoneConversion ? this.localTimeToUtcTime(endOfDay) : new Date(endOfDay)
        },
        formatLocalDate(date) {
            let shiftedDate = new Date(date.getTime());

            let year = shiftedDate.getFullYear();
            let month = (shiftedDate.getMonth() + 1).toString().padStart(2, '0'); // Ensure two digits
            let day = shiftedDate.getDate().toString().padStart(2, '0'); // Ensure two digits
            let hours = shiftedDate.getHours().toString().padStart(2, '0');
            let minutes = shiftedDate.getMinutes().toString().padStart(2, '0');
            let seconds = shiftedDate.getSeconds().toString().padStart(2, '0');

            return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
        },
        getStartOfTheDay: function (date, zoneConversion = true) {
            let startOfDay = new Date(date)
            startOfDay.setHours(0, 0, 0, 0)
            return zoneConversion ? this.localTimeToUtcTime(startOfDay.getTime()) : startOfDay
        },
        getStartOfWeek: function (date) {
           let dateTyped = new Date(date)
           let weekDayNum = dateTyped.getDay()
           if (weekDayNum === 0) {
               // Sunday
               weekDayNum = 7
           }
           let diffFromFirstDay = weekDayNum - 1;
           dateTyped.setTime(dateTyped.getTime() - (diffFromFirstDay * this.DAY_IN_MILLIS))
           dateTyped.setHours(0,0,0,0)
           return dateTyped
        },
        getCurrentDay: function () {
            return new Date().toISOString().substring(0, 10)
        },
        getToday: function () {
            let d = new Date();
            d.setDate(d.getDate())
            return this.getDateIsoString(d)
        },
        getTwoYearsAgo: function () {
            let d = new Date();
            d.setFullYear(d.getFullYear() -1)
            d.setMonth(0, 1)
            return this.getDateIsoString(d)
        },
        getYesterday: function () {
            let d = new Date();
            d.setDate(d.getDate() - 1)
            return this.getDateAsString(d)
        },
        getYesterdayAsDate() {
            let d = new Date();
            d.setDate(d.getDate() - 1)
            return d;
        },
        getMonthStart: function () {
            return this.getDateIsoString(this.getMonthStartAsDate())
        },
        getDayStart: function () {
            let today = new Date()
            today.setHours(0,0,0)
            return this.getDateIsoString(today)
        },
        getDateAsString: function (date) {
            let month = date.getMonth() + 1
            if (month < 10) {
                month = '0' + month;
            }
            let day = date.getDate()
            if (day < 10) {
                day = '0' + day;
            }
            return date.getFullYear() + '-' + month + '-' + day
        },
        getMonthStartAsDate: function () {
            let date = new Date()
            return new Date(date.getFullYear(), date.getMonth(), 1)
        },
        getMonthEnd: function () {
            return this.getDateIsoString(this.getMonthEndAsDate());
        },
        getMonthEndAsDate: function () {
            let date = new Date();
            return new Date(date.getFullYear(), date.getMonth() + 1, 0);
        },
        getDateIsoString: function (d) {
            let month = d.getMonth() + 1
            if (month < 10) {
                month = '0' + month;
            }
            let day = d.getDate()
            if (day < 10) {
                day = '0' + day;
            }
            return d.getFullYear() + '-' + month + '-' + day + 'T00:00'
        },
        isInPast: function (dateStr) {
            if (dateStr) {
                let d = new Date(this.setTime(dateStr))
                let now = new Date()
                return now.getTime() > d.getTime()
            }
            return true
        },
        withinMonth: function (dateStr)  {
            if (dateStr) {
                let d = new Date(this.setTime(dateStr))
                let now = new Date()
                const month = 30 * 24 * 60 * 60 * 1000 // 30 days
                return (now.getTime() + month) > d.getTime()
            }
            return false
        },
        withinYear: function (dateStr)  {
            if (dateStr) {
                let d = new Date(this.setTime(dateStr))
                let now = new Date()
                const year = 365 * 24 * 60 * 60 * 1000 // 365 days
                return (now.getTime() + year) > d.getTime()
            }
            return false
        },
        getWeekNumber: function (date) {
            let modDate = new Date(date)
            var dayNum = modDate.getUTCDay() || 7;
            modDate.setUTCDate(modDate.getUTCDate() + 4 - dayNum);
            var yearStart = new Date(Date.UTC(modDate.getUTCFullYear(),0,1));
            return Math.ceil((((modDate - yearStart) / 86400000) + 1)/7)

        },
        timestampToISOString: function (timestamp) {
            if (!timestamp || timestamp < 1) {
                return null
            }
            var date = new Date(timestamp)
            var year = date.getFullYear()
            var month = date.getMonth() + 1
            var day = date.getDate()
            var hour = date.getHours()
            var min = date.getMinutes()
            var result = year + '-'
            if (month < 10) {
                result += '0'
            }
            result += month + '-'
            if (day < 10) {
                result += '0'
            }
            result += day
            result += 'T' + (hour > 9 ? hour : '0' + hour) + ':' + (min > 9 ? min : '0'+min)
            return result
        },

        getMinutesThisWeek() {
            const currentDate = new Date()
            const startOfWeek =  this.getStartOfWeek(currentDate)
            return (currentDate - startOfWeek) / (60 * 1000)
        },

        getMinutesThisMonth() {
            const currentDate = new Date()
            return (currentDate.getDate() - 1) * 24 * 60 + currentDate.getHours() * 60 + currentDate.getMinutes()
        },

        isToday(timeStr) {
            const givenTime = new Date(timeStr)
            const currentDate = new Date();
            const givenYear = givenTime.getFullYear();
            const givenMonth = givenTime.getMonth();
            const givenDay = givenTime.getDate();
            const currentYear = currentDate.getFullYear();
            const currentMonth = currentDate.getMonth();
            const currentDay = currentDate.getDate();
            return givenYear === currentYear && givenMonth === currentMonth && givenDay === currentDay;
        },

        isThisWeek(timeStr) {
            const givenTime = new Date(timeStr)
            const currentDate = new Date();
            const givenWeek = this.getISOWeek(givenTime);
            const currentWeek = this.getISOWeek(currentDate);
            return givenWeek === currentWeek;  //Year not start always on monday
        },

        isThisMonth(date) {
            const d = new Date(date)
            const cD = new Date()
            return d.getMonth() === cD.getMonth()
        },

        getISOWeek(date) {
            const d = new Date(date);
            d.setHours(0, 0, 0, 0);
            d.setDate(d.getDate() + 4 - (d.getDay() || 7));
            const yearStart = new Date(d.getFullYear(), 0, 1);
            return Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
        },
        /**
         * Get hours and mintues from date string
         * @param {string} isoString
         */
        getTimeFromDate(isoString) {
            const date = new Date(isoString);
            return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        },
        getHoursDifference(startDate, endDate) {
            const start = new Date(startDate);
            const end = new Date(endDate);

            const differenceInMs = end - start;
            const differenceInHours = differenceInMs / (1000 * 60 * 60);

            return differenceInHours;
        },
        utcToLocalTimeString(inputStr) {
            let date = new Date(inputStr)
            const timeZoneOffsetInMs = date.getTimezoneOffset() * 60 * 1000;
            return (new Date(date.getTime() - timeZoneOffsetInMs)).toISOString()
        },
        /**
         * Computes the min/max `created` date range from a list of assignments,
         * ignoring assignments with a missing, empty, or unparsable `created` value.
         * @param {Array<{created: string}>} assignments
         * @returns {{start: Date, end: Date} | null} null when no assignment has a valid created date
         */
        getWorkassignmentPeriod(assignments) {
            const list = Array.isArray(assignments) ? assignments : []
            const validDates = list
                .filter(assignment => assignment && assignment.created && !isNaN(new Date(assignment.created).getTime()))
                .map(assignment => new Date(assignment.created))

            if (validDates.length === 0) {
                return null
            }

            let start = validDates[0]
            let end = validDates[0]
            for (const date of validDates) {
                if (date.getTime() < start.getTime()) {
                    start = date
                }
                if (date.getTime() > end.getTime()) {
                    end = date
                }
            }

            return { start, end }
        },

        /**
         * Formats the workassignment period for display, fully localized.
         * - No valid dates -> $t('work_assignment.workassignment_period_empty')
         * - Single calendar day -> single $d() short date
         * - Multiple calendar days -> "start" + $t('work_assignment.workassignment_period_separator') + "end"
         * Uses the same { dateStyle: 'short' } convention as getShortDateString.
         * @param {Array<{created: string}>} assignments
         * @returns {string}
         */
        formatWorkassignmentPeriod(assignments) {
            const period = this.getWorkassignmentPeriod(assignments)

            if (period === null) {
                return this.$t('work_assignment.workassignment_period_empty')
            }

            const { start, end } = period
            const sameDay = start.getFullYear() === end.getFullYear() &&
                start.getMonth() === end.getMonth() &&
                start.getDate() === end.getDate()

            if (sameDay) {
                return this.$d(start, { dateStyle: 'short' })
            }

            return this.$d(start, { dateStyle: 'short' }) +
                this.$t('work_assignment.workassignment_period_separator') +
                this.$d(end, { dateStyle: 'short' })
        }
    }
}
